import { Dialog,  DialogContent, DialogContentText, DialogTitle, Divider, Grid2 as Grid, IconButton, List, ListItem, Skeleton} from "@mui/material";
import { SaleHistory, Transaction } from "../types";
import SaleCard from "./SaleCard";
import CloseIcon from '@mui/icons-material/Close';

type Props = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedTransaction: Transaction | undefined;
  saleHistory: SaleHistory[];
  loadingSaleHistory: boolean;
}

function SaleHistoryDialog(props: Props) {

  return (<Dialog
    open={props.open}
    onClose={()=>props.setOpen(false)}
    scroll="paper"
  >
    <DialogTitle >Sale History</DialogTitle>
    <IconButton
          aria-label="close"
          onClick={()=>props.setOpen(false)}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
        <CloseIcon />
      </IconButton>
    <DialogContent dividers={true}>
      <DialogContentText>
        <List>
          <ListItem>
            <b>Parcel #:</b>&nbsp;{props.selectedTransaction?.parcelNumber}
          </ListItem>
          <ListItem>
            <b>Parcel Type:</b>&nbsp;{props.selectedTransaction?.Parcel.parcelType === 81 ? "Commercial" : "Industrial"}
          </ListItem>
          <ListItem>
            <b>Street Address:</b>&nbsp;{props.selectedTransaction?.Parcel.streetAddress}
          </ListItem>
          <ListItem>
            <b>City:</b>&nbsp;{props.selectedTransaction?.Parcel.city}
          </ListItem>
          <ListItem>
            <b>Zipcode:</b>&nbsp;{props.selectedTransaction?.Parcel.zip}
          </ListItem>
          <ListItem>
            <b>Neighborhood:</b>&nbsp;{props.selectedTransaction?.Parcel.neighborhood}
          </ListItem>
          <ListItem>
            <b>Market Area:</b>&nbsp;{props.selectedTransaction?.Parcel.marketArea}
          </ListItem>
          <ListItem>
            <b>Acres:</b>&nbsp;{props.selectedTransaction?.Parcel.acres}
          </ListItem>
        </List>
        <Divider />
        <Grid container spacing={2}>
        { props.loadingSaleHistory ?
          <>
          <Grid size={12}>
            <Skeleton variant="rectangular" width="250px" height="350px" />
          </Grid>
          <Grid size={12}>
            <Skeleton variant="rectangular" width="250px" height="350px" />
          </Grid>
          <Grid size={12}>
            <Skeleton variant="rectangular" width="250px" height="350px" />
          </Grid>
          </>
          :
          props.saleHistory.map( sale => <Grid size={12}>
            <SaleCard 
                sale={sale}
            />
          </Grid>)}
        </Grid>
      </DialogContentText>
    </DialogContent>
  </Dialog>);
}

export default SaleHistoryDialog;
